<tool-drawer-container [shouldShowToggleBtn]="false">
  <about-page-main-content class="main-content"></about-page-main-content>
</tool-drawer-container>
